// extracted by mini-css-extract-plugin
module.exports = {"title":"_fa24afc8","description":"_58a0546e"};